<style>
@media screen and (max-width: 1024px){
  
  .footer-box-icp{height:100%!important;font-size:12px!important}
  .footer-box .footer-bottom-box{height:auto!important;flex-direction: column;align-items: center!important;}
  .footer-box .footer-bottom-box .footer-left .jd-icon{width:auto!important;height:50px!important;margin-left: 55px!important;}
  .footer-box .footer-bottom-box .link-text{font-size:12px!important;text-align: center;}
  .footer-left{text-align: center;}
  .foot-right{display: none !important;;}
  .footer-box .footer-bottom-box .foot-center{margin-left:0px!important;}
  .footer-box .footer-bottom-box .foot-center .foot-link-col-box .foot-link-title{font-size: 14px!important;}
  .footer-box .footer-bottom-box .foot-center .foot-link-col-box{margin-right: 1.5vw!important;text-align: center!important;}
  
  
  .footer-box .footer-top-box{height:auto!important;}
  .footer-box .footer-top-box .form-box .el-input{width:45%!important;}
  .footer-box .footer-top-box .form-box .ipt-pre-icon{width:10px!important;}
  .footer-box .footer-top-box .form-box .el-input__inner{font-size:10px!important;}
  .footer-box .footer-top-box .confirm-btn{font-size:12px!important;width:100px!important;height:20px!important;;}
  .footer-box .footer-top-box .text4{font-size:10px!important;}
  .footer-box .footer-top-box .text1, .footer-box .footer-top-box .text2{font-size: 14px!important;}
  .footer-box .footer-top-box .text3{font-size: 12px!important;}
  .footer-box .footer-top-box .form-box .el-input__inner{height: 30px!important;}
  .el-carousel__container{height: 30px!important;}
  .footer-box .footer-top-box{padding-top:0px!important;}
}

.global-tooltip {
  position: fixed;
  top: 30%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(0,0,0,0.85);
  color: #fff;
  padding: 12px 24px;
  border-radius: 6px;
  font-size: 16px;
  z-index: 99999;
  text-align: center;
}
</style>
<template>
  <div>
    <footer class="footer-box">
      <div class="footer-top-box">
        <img src="/img/foot-bg.b0089fc.png" class="footer-top-bg" />
        <div class="text1">Trở thành đối tác Fast Charge</div>
        <div class="tips-carousel">
          <el-carousel height="40px" direction="vertical" :autoplay="true">
            <el-carousel-item v-for="item in link.filter(l => l.gid === 2)" :key="item.id">
              <div class="text3">{{ item.name }}</div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="form-box">
          <el-input placeholder="Vui lòng nhập tên của bạn" v-model="name">
            <template #prepend>
              <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAnCAYAAABqippxAAAAAXNSR0IArs4c6QAAA3FJREFUWEfNmF2IVlUUhp83ierCxLIoiay8Cuyq6KKwgizKgpB+QERBhIKQSiYomgoKKsFuxIgSQoMgEwcMDAzxBzMoEWEoimqmMDG0KFJCy5+W+4U9w8w437fPOd8xWjfzwdl77We/e+211h5RwyLiQuAy4B5gAXAzcDnwDzAM7AA+AoYk/VXDNao6OCKmAXcDzwC3AVM6zP0DeAdYB/wo6d8qa1QCiYjpwCLg2bTArAqOTwCfAK8l5QYlRWlOESQiLgYeBl4Fbig5HPPdMBuBVyT9VJpXBeRG4G3gzuS0OH7Cgj6mF31Mkv7uBtPVcURclM55SQrINYB/N7GtwNOSvu8F5ArgLeCxJgR5zlHgEWB7t1gpKXIt4B35eHqxJ4D1kk52clICcXB+BszshQJ4zspKOt4U5LoUpDvTbvy3F1sBvCvJN2lSKyliJTak853bA8XpnIMGJJ1pCnIp8FJOZE1ZhlL6Xyzpi15uzQXAvcAHuaY0gVkLvCzpSGMQT4yIGcDzwPKaucRp/WvXJkkuhl2tUqaMiDlO1cB8wCm/ZC50P6exK/O1dXVuBcTAtwBPAQ8ALoKdzBCDviXAh5KOlSD8vZIiI44iwnnlfuDB3Is4846Yd/0DsAvYDOyRVFRiZHItkBwzbo5mA9enXV8NuE9xxvwVOAR8J+n3KiqMHVMbZOzk3LE5ZpwfTlTpOzoBVgKJCHdjXvDKJP1dSfZ5WZGrsiI+gt+yIvtTPG1JhfKbdNtc+k9VASxlVgN4sdtzO3AHMLWC7M6mjhdn5Y/z766KdQSJiEtyMnOLeF9FgImMvkFf5YToAB7upM6kIBHhztwNkXvUXiuv4RzM7mFXSto7maLngESEexDni6X56VDhJCoP2Q2sMtREZcaBZCX6gWWAC17b5qPa55Ihye3FqI2C5G79ySTjCz0UuCrgDuRtQJ+kb8cltHw9/XJb3VJMlICszPvetKTDoyk+IvxoejM3uSUnbX3/xaoAmySdVs6O7tL9djkfcdENfCAf0QGD+Kq+BzzU1lZr+Pkzt5GfGsRPhc8Lpb2G79pDX08N1xsGeTz3DrU9tDThS5+GQfxQfrQlp03c+DrfZBAT3drEQ4tz5hnkIHBNi06buFpiEPcMTV/6TRadbE6fQYr/zWlrtS5++v9XIAv/gx2Xlhg8C6lUBZfV9k8OAAAAAElFTkSuQmCC"
                class="ipt-pre-icon" />
            </template>
          </el-input>
          <el-input placeholder="Nhập số điện thoại để nhận chính sách ưu đãi mới nhất miễn phí" v-model="phone">
            <template #prepend>
              <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAmCAYAAADa8osYAAAAAXNSR0IArs4c6QAAAe1JREFUWEft182rjVEUx/HPRt5LokR5KxkwUcoIJRNXMZIMlPgHlJQhRfIy4tYtZKQ7MFFmysBIYqQYGRi4Eim6IQPc7Vm3fTiOc85zOmf67NnTs9b+7rX2es75/RLknBdjB05gL1Yjxbsh1lc8xW08wHRKaSblnJfgOE5j/RAb90qZxh1cSSlNBWisquBGdYK1fSCv8RIzHTFrSid6pX7BRYwH6D4O1lQyHsH40RG3s5y6X/or7AvQJyyvAU3hbVxnR9wybK3J/YXdAYp2DHvxg17pWIBapwzgO0RfR10LsA7zykb720Hfq9acxaNRKdiICazsBor5P5ZSujcqKOe8BQ8RUxnrn4oaUM8ON60bevia1jWt+9OBZhiaYWiGofkr//8rqPtlCLl1FY+H/oD+Joamu1TJ6BXdVFAIyI/4VgMKwVmnbOcX6zO3HTSoJA4bcg5hCrZXKvQCNg8ADdasJI4qWoqyXzGTKaWjrYCc8ymcr/xPmLh+K0T+rgDdxeEB7uV6SulkGyjc4TUsrckNX3UgQHsq6XoTm2oSXhTr+RwbcLn4qpaQ75b+ubT7VoAWVW7uEM4gNHOvi/6JgL0p07StppoPpYCJlNL72U1zzgsL5Egxy6swp0eFLZvT7UDxLmzPM0ziSTynlPJvR3pnkqfA1vsAAAAASUVORK5CYII="
                class="ipt-pre-icon" />
            </template>
          </el-input>
        </div>
        <div class="confirm-btn" @click="submitFormmsg2">Gửi ngay</div>
        <div class="text4">Đầu tư có rủi ro, xin hãy cân nhắc kỹ trước khi quyết định</div>
      </div>

      <div class="footer-bottom-box">
        <div class="footer-left">
          <img :src="BASE_URL +label.footer_logo" class="jd-icon" />
          <div class="link-text">
            <a v-for="item in link.filter(l => l.gid === 1)" :key="item.id" :href="item.link" target="_blank" class="link-text">{{ item.name }} </a>
          </div>
          <div class="link-text address">Địa chỉ:</div>
          <div class="link-text">{{ long.address }}</div>
          <div class="link-text address">Điện thoại liên hệ: {{ long.phone }}</div>
        </div>
        <div class="foot-center">
          <div class="foot-link-col-box">
            <div class="foot-link-title">Sản phẩm Fast Charge</div>
            <div class="link-text"><a href="hotProducts?anchor=powerBank" class="link-text">Sạc dự phòng</a></div>
            <div class="link-text"><a href="hotProducts?anchor=chargingPile" class="link-text">Trạm sạc</a></div>
            <div class="link-text"><a href="hotProducts" class="link-text">Sản phẩm khác</a></div>
          </div>
          <div class="foot-link-col-box">
            <div class="foot-link-title">Tuyển đại lý</div>
            <div class="link-text">Chính sách ưu đãi</div>
            <div class="link-text">Quyền lợi đối tác</div>
            <div class="link-text">Tìm hiểu thêm</div>
          </div>
          <div class="foot-link-col-box">
            <div class="foot-link-title">Về chúng tôi</div>
            <div class="link-text"><a href="about" class="link-text">Tìm hiểu về Fast Charge</a></div>
          </div>
        </div>
        <div class="foot-right">
          <div class="foot-right-row">
            <img
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAlCAYAAAAwYKuzAAAAAXNSR0IArs4c6QAAAvtJREFUWEftmEuoTVEYx3+f97NI8ojkkUcojyTPgRRhwNhIJgaSMkcyke6AiZiYeYwuSrl0M7oihFIy8RbSVVyuy3V99v+0dh3H2mff2sc9Z3BW7fbunG+t77e+9a39/dc2AHcfCcwH1gPTgTGA6b8BbN3AW+AO8AjoMjM3dx8FbAY2AEMHECjL1W/gHnAJ+CTA5cCuBoFLoT0AtgtwP7CgASJXifAeOC7AlpBzjcb4KwE6LMDTjUZWxnO0CVhwdZoRLBhAmhH87xHsBV4DX4DxoU4PinhVeXqj0gSMBWYAQzLo9AL+AIwIdrpntdwlVtG+DrwLcNuBmZHRngFXgRfARGArsDhi9xG4AjwJE1H9X1cE8Gzi7K6Z9bm7hMRGQJCVTYX9ppn1uPtgQPV9d8SuA2g1sy53l1rSZA9UiXZuBM8Bt8ys192HJSpjG7Ap4vga0GZm3e6upV0N7IzY3U/q/kUz++zuShVJvL2AJhVruYDKq7ZE7bwMg20BxkVG6gx2T4FpYYmnRuy+JUvaDjwIOS2ZN7fIEiv5JSR/AsMTdTE6YzDJI9n9CLKtmuD9DvSEqMkutulSN7kRLPqaKNq/CdiMYNEIFO1fysFTOTupqJMi/Y8I8FjGu63IwLXoKx1wUID7gIW1GLHGY6j+l051S4A9dfiSkDefVlUdAUru7AiqQm/1gf7kUQmq6vU4Ka0XzKyzBBMgpUBWhRqZVX5i8BIH+raTpf8qAaQt+8KPKpFpE9jXRC09BDrMTHb/RivIIIGUX6ltCq7/0ucpIfrzwmartgKCOAG8SjaAnnUJsnQ3M93/ajVZziDFlgIrgdlBLWfl2BlFSRozLwmjEexPpywbd58QtKDUtGRXTOddBm5IY/bHV00iWO4oCNY5ibRfBiwCBF3ebgPnpb7rAhg2nSauw5PyckW4p4ej58BJqe+6AaaOQzQVQUVyLTAZkGA9pHNJ3QHLQKXGJyW5tyZspBYz03E2t9U8B6tsIPnSwWuWztlmpu/Rue0PPJYJVQ9VFHwAAAAASUVORK5CYII="
              class="right-title-icon" />
            <div class="right-title-text" @click="handleRightTitleClick">Tư vấn trực tuyến</div>
          </div>
          <div class="foot-right-row">
            <img src="/img/jmrx-icon.21cebf4.png" class="right-title-icon" />
            <div>
              <div class="right-title-text">Hotline nhượng quyền</div>
              <div class="right-value-box">{{ long.phone }}</div>
            </div>
          </div>
          <div class="foot-right-row">
            <img src="/img/gzjd-icon.cbdcb95.png" class="right-title-icon" />
            <div>
              <div class="right-title-text">Theo dõi Fast Charge</div>
              <div class="right-value-box">
                FB.WS.TK.Viber
              </div>
            </div>
          </div>
        </div>
        <img src="/img/jiedian.4cc5380.png" class="footer-bottom-bg" />
      </div>
      <div class="footer-box-icp">
         {{ long.copyright }}
        <a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index" style="color: #fff">
           {{ long.icp }}
        </a>
      </div>
      <div v-if="globalTooltip.visible" class="global-tooltip">
        {{ globalTooltip.message }}
      </div>
    </footer>
  </div>
</template>
<script>

import { BASE_URL } from '@/config';
import qs from 'qs';

import axios from 'axios'; // 引入 axios
export default {
  name: "vueFooter", // 组件名称
  props: {
    long: {
      type: Object,
      default: () => ({})
    },
    link: {
      type: Array,
      default: () => []
    },
    label: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      name: '',
      phone: '',
      
      showNameTooltip: false, // 是否显示姓名提示
      showPhoneTooltip: false, // 是否显示手机号提示
      globalTooltip: { // 全局提示框状态
        visible: false,
        message: ""
      },
      value: [],
      BASE_URL
    };
  },
  methods: {
    handleRightTitleClick() {
    // 主页面元素
    const iconChat = document.querySelector('.icon-chat');
    const chatClass = document.querySelector('.chat-class');
    const formClass = document.querySelector('.form-input-class');
    const followClass = document.querySelector('.follow-class');
    const iconApply = document.querySelector('.icon-apply');
    const iconFollow = document.querySelector('.icon-follow');

    if (iconChat && chatClass) {
      if (iconChat.classList.contains('active')) {
        iconChat.classList.remove('active');
        chatClass.style.display = 'none';
      } else {
        // 只显示 chat-class，隐藏其它
        iconChat.classList.add('active');
        chatClass.style.display = '';
        if (formClass) formClass.style.display = 'none';
        if (followClass) followClass.style.display = 'none';
        if (iconApply) iconApply.classList.remove('active');
        if (iconFollow) iconFollow.classList.remove('active');
      }
    }
  },
    
 
  submitFormmsg2() {
      if (!this.name) {
        this.showGlobalTooltip("Vui lòng điền tên của bạn");
        return;
      }
      if (!this.phone) {
        this.showGlobalTooltip("Vui lòng nhập số điện thoại trước");
        return;
      }
      if (!/^1[3-9]\d{9}$/.test(this.phone)) {
        this.showGlobalTooltip("Số điện thoại sai hoặc trống");
        return;
      }
      axios.post('https://admin.metfastcharge.net/index/msg?fcode=1&lang=vn', qs.stringify({
        name: this.name,
        phone: this.phone
      }), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
      .then(response => {
        if (response.data.status === 'success') {
          this.showGlobalTooltip('Thông điệp thành công!');
          // 清空表单
          this.name = '';
          this.phone = '';
        }
        if (response.data.status === 'fail') {
          this.showGlobalTooltip('Thông điệp thất bại');
        }
      })
      .catch(error => {
        console.error("提交失败：", error);
        this.showGlobalTooltip("Gửi không thành công, vui lòng kiểm tra kết nối mạng!");
      });
    },
    
    showGlobalTooltip(message) {
      this.globalTooltip.message = message;
      this.globalTooltip.visible = true;

      if (this.tooltipTimer) {
        clearTimeout(this.tooltipTimer);
        this.tooltipTimer = null;
      }

      this.tooltipTimer = setTimeout(() => {
        this.globalTooltip.visible = false;
        this.tooltipTimer = null;
      }, 3000);
    }
  },
  mounted() {
    this.loadProvinces();
  },
  
};
</script>